import {
  BackspaceOutlined,
  LocalAtm,
} from "@mui/icons-material";
import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Modal,
  Spinner,
  Button,
  Form, Row, Col
} from "react-bootstrap";
import { APP_COLOR, COLOR_WHITE, LINEAR_GRADIENT_BG, SHOP_SETTING_KEY } from "../../const";
import { convertCurrency, FormatNumber, numberFormat } from "../../helper";
import { errorSwal } from "../../helper/sweetalert";
import NumberButton from "./NumberButton";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import ReactToPrint from "react-to-print";
import useWindowDimensions from "../../helper/windowDimensions";
import { useTranslation } from "react-i18next";
import { ReactIcons } from "../../icons";
import _ from "lodash";
import RewardExchangeModal from './RewardExchangeModal';
import { useMutation } from "@apollo/client";
import { CREATE_REDEEM } from "../../apollo/redeem/Mutation";
import Swal from "sweetalert2";

const shipping_cost_title = "ຄ່າຂົນສົ່ງ";
const repair_cost_title = "ຄ່າແຮງງານ";

function CalculatorModal({
  activeTab,
  setActiveTab,
  createOrderLoading,
  saleOfferPriceLoading,
  receivedMoney,
  setReceivedMoney,
  change,
  setChange,
  totalPricePay,
  showDetailSaleModal,
  setShowDetailSaleModal,
  onPrintBill,
  selectedPayCurrency,
  setSelectedPayCurrency,
  setShowSelectCusTomer,
  customername,
  loadingPrintBill,
  createOrderPrintBill,
  createOrderNotPrintBill,
  loadingSaleBill,
  createOrderNotYetPaidLoading,
  setNotYetPaid,
  bill80Ref,
  handleCreateOrderForPrintUsb,
  setCartDatas,
  cartDatas,
  serviceOther,
  setServiceOther,
  activeCart,
  handleOpentOfferprice,
  shopData,
  setIsBillPrinting,
  billA4Ref, promotionData,
  currentPoint,
  refetchUserConfirm,
  _loadGenCode,
  userconfirmId,
}) {
  const printA4Ref = useRef();

  // Handler to run after printing A4 bill
  const [previewingA4, setPreviewingA4] = useState(false);
  const [showRewardExchange, setShowRewardExchange] = useState(false);
  // Keep previous discount values to allow reverting when canceling reward
  const [selectedReward, setSelectedReward] = useState(null);
  const [prevOrderGroupDiscount, setPrevOrderGroupDiscount] = useState(null);
  const [prevOrderGroupDiscountType, setPrevOrderGroupDiscountType] = useState(true);
  // Clear discounts across all carts and serviceOther
  const clearAllDiscounts = () => {
    try {
      setCartDatas((prev) =>
        (Array.isArray(prev) ? prev : []).map((cart) => ({
          ...cart,
          data: {
            ...cart?.data,
            orderGroup: {
              ...cart?.data?.orderGroup,
              discount: 0,
              discountType: true,
              discountAmountApplied: 0,
              // Clear any previously selected rewardId when clearing discounts
              rewardId: undefined,
            },
          },
        }))
      );

      setServiceOther((prev) => {
        const list = Array.isArray(prev) ? prev : [];
        return list.map((c) => ({
          ...c,
          discount: null,
          discountType: true,
          maxDiscountAmount: undefined,
          discountAmountApplied: 0,
        }));
      });

      setDiscountType(true);
      setNewServiceOther((prev) => ({ ...prev, discount: null, discountType: true }));
    } catch (e) {
      console.error("Error clearing discounts globally:", e);
    }
  };
  const handleSelectReward = (reward) => {
    try {
      // Ensure only one reward (discount) is active across all carts
      if (reward?.rewardType === "DISCOUNT") {
        clearAllDiscounts();
        const percent = Number(reward?.percent) || 0;
        const maxDiscountAmount = Number(reward?.maxDiscountAmount) || 0;
        // ใช้ส่วนลดเป็นเปอร์เซ็นต์เหมือน modal ບໍລິການອື່ນໆ
        setDiscountType(false);
        setNewServiceOther((prev) => ({ ...prev, discount: percent }));
        // Remember current discount values for active cart to support revert
        const selectedCart = (Array.isArray(cartDatas) ? cartDatas : []).find((cart) => cart?.label === activeCart);
        const currentDiscount = selectedCart?.data?.orderGroup?.discount ?? 0;
        const currentDiscountType = selectedCart?.data?.orderGroup?.discountType ?? true;
        setPrevOrderGroupDiscount(currentDiscount);
        setPrevOrderGroupDiscountType(currentDiscountType);
        // อัปเดต serviceOther ให้สอดคล้องกับ cart ที่ใช้งานอยู่
        const other = {
          activeCart,
          shippingCost: null,
          costType,
          discountType: false,
          discount: percent,
          maxDiscountAmount,
          discountAmountApplied: 0,
        };
        setServiceOther((prev) => {
          const list = Array.isArray(prev) ? prev : [];
          const idx = list.findIndex((c) => c?.activeCart === activeCart);
          if (idx !== -1) {
            const updated = [...list];
            updated[idx] = { ...updated[idx], ...other };
            return updated;
          }
          return [...list, other];
        });
        // อัปเดต cartDatas เพื่อแสดงส่วนลดในหน้าตะกร้า (ไม่บันทึก maxDiscountAmount ใน orderGroup)
        setCartDatas((prev) =>
          (Array.isArray(prev) ? prev : []).map((cart) => {
            if (cart?.label === activeCart) {
              return {
                ...cart,
                data: {
                  ...cart?.data,
                  orderGroup: {
                    ...cart?.data?.orderGroup,
                    discount: percent,
                    discountType: false,
                    discountAmountApplied: 0,
                    // Persist selected rewardId to orderGroup for backend
                    rewardId: reward?.id,
                  },
                },
              };
            }
            return cart;
          })
        );
      } else if (selectedReward?.rewardType === "DISCOUNT") {
        // Switching from discount to item: clear all discounts globally first
        clearAllDiscounts();
      }
      // For ITEM reward or any non-discount, still persist rewardId to active cart
      if (reward && reward?.rewardType !== "DISCOUNT") {
        setCartDatas((prev) =>
          (Array.isArray(prev) ? prev : []).map((cart) => {
            if (cart?.label === activeCart) {
              return {
                ...cart,
                data: {
                  ...cart?.data,
                  orderGroup: {
                    ...cart?.data?.orderGroup,
                    rewardId: reward?.id,
                  },
                },
              };
            }
            return cart;
          })
        );
      }
    } catch (e) {
      console.error("Error applying reward discount:", e);
    }
    // Always set current selection to the latest reward and close modal
    setShowRewardExchange(false);
    setSelectedReward(reward);
  };
  // Cancel selected reward and restore previous discount values
  const handleCancelSelectedReward = () => {
    try {
      if (selectedReward?.rewardType === "DISCOUNT") {
        // Clear discounts from ALL carts and service entries
        clearAllDiscounts();
      }
      // Clear rewardId in all carts when canceling selected reward
      setCartDatas((prev) =>
        (Array.isArray(prev) ? prev : []).map((cart) => ({
          ...cart,
          data: {
            ...cart?.data,
            orderGroup: {
              ...cart?.data?.orderGroup,
              rewardId: undefined,
            },
          },
        }))
      );
    } catch (e) {
      console.error("Error canceling reward and clearing discounts:", e);
    } finally {
    }
    setSelectedReward(null);
  };
  // Auto redeem when proceeding to bill actions if a reward is selected
  const autoRedeemIfNeeded = async () => {
    try {
      if (!selectedReward || !userconfirmId) return;
      if (currentPoint < (selectedReward?.pointMin || 0)) {
        Swal.fire({
          title: "ຄະແນນບໍ່ພໍ",
          text: `ຕ້ອງການ ${selectedReward.pointMin} ຄະແນນ, ມີ ${currentPoint ?? 0} ຄະແນນ`,
          icon: 'warning'
        });
        return;
      }
      await createRedeem({
        variables: {
          data: {
            reward: selectedReward?.id,
            shop: selectedReward?.shop?.id,
            userConfirm: userconfirmId,
          }
        }
      });
    } catch (error) {
      console.error('Auto redeem failed:', error);
    }
  };
  const handleAfterPrintA4 = async () => {
    setPreviewingA4(false);
    await setNotYetPaid(false);
    setIsBillPrinting(true);
    await autoRedeemIfNeeded();
    handleCreateOrderForPrintUsb();
  };

  const handlePrintA4 = async (e) => {
    try {
      // await _loadGenCode();
      if (loadingPrintBill || saleOfferPriceLoading) {
        return;
      }
      if (receivedMoney - totalPricePay < 0) {
        errorSwal("ຈໍານວນເງິນບໍ່ພໍ");
        return;
      }
      await autoRedeemIfNeeded();
      setPreviewingA4(true);
      printA4Ref.current.handlePrint();
    } catch (error) {
      console.log("Error in handlePrintA4: ", error);
    }
  };

  const [money, setMoney] = useState("0");
  const { t } = useTranslation();
  const [swicthMode, setSwicthMode] = useState(false);
  const [costType, setCostType] = useState(shipping_cost_title);
  const { printBillA4 } = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY));
  const [discountType, setDiscountType] = useState(true);

  // ===== Redeem Mutation for Confirm Action =====
  const [createRedeem, { loading: createRedeemLoading }] = useMutation(CREATE_REDEEM, {
    onCompleted: async (data) => {
      // Refetch user confirm data to get updated currentPoint from backend
      if (refetchUserConfirm) {
        try {
          await refetchUserConfirm();
        } catch (error) {
          console.error('Error refetching user confirm:', error);
        }
      }
      
      
      Swal.fire({
        title: "ແລກລາງວັນສຳເລັດ!",
        icon: 'success',
        timer: 1500,
        showConfirmButton: false
      });
      setSelectedReward(null);
    },
    onError: (error) => {
      Swal.fire({
        title:"ເກີດຂໍ້ຜິດພາດ",
        text: error?.message || "ກະລຸນາລອງໃໝ່ອີກຄັ້ງ",
        icon:'error'
      })
    }
  });

  

  useEffect(() => {
    setMoney(totalPricePay.toString());
  }, [totalPricePay]);

  useEffect(() => {
    setChange(parseFloat(receivedMoney) - parseFloat(money));
  }, [receivedMoney]);
  useEffect(() => {
    if (!showDetailSaleModal) {
      setChange(0);
      // Keep selected reward and rewardId persisted when closing the modal
    }
  }, [showDetailSaleModal]);

  // useEffect(() => {
  //   if (activeCart === "Bill 1") {
  //     setServiceOther((prevState) => ({
  //       ...prevState,
  //       shippingCost: cartDatas[0]?.data?.orderGroup?.shippingCost,
  //     }));
  //   } else if (activeCart === "Bill 2") {
  //     setServiceOther((prevState) => ({
  //       ...prevState,
  //       shippingCost: cartDatas[1]?.data?.orderGroup?.shippingCost,
  //     }));
  //   } else {
  //     setServiceOther((prevState) => ({
  //       ...prevState,
  //       shippingCost: cartDatas[2]?.data?.orderGroup?.shippingCost,
  //     }));
  //   }
  // }, [activeCart]);

  const handleClick = (value) => {
    setReceivedMoney(receivedMoney + value);
  };

  const { height, width } = useWindowDimensions()


  const handleChange = (event) => {
    const newValue = event.target.value.replace(/[^\d.]/g, "");
    setReceivedMoney(newValue);
  };

  const backspace = () => {
    setReceivedMoney(receivedMoney.slice(0, -1));
  };

  const [newServiceOther, setNewServiceOther] = useState({});
  const handleSwitchMode = () => {
    try {
      setSwicthMode(true);
      if (!activeCart) {
        setNewServiceOther({});
        return {};
      };
      if (!serviceOther) {
        setServiceOther([]);
        setNewServiceOther({});
        return {};
      };
      const other = {
        activeCart: activeCart,
        shippingCost: null,
        costType: costType,
        discountType: discountType,
        discount: null,
      }; 
      if (!serviceOther || serviceOther.length <= 0) {
        setServiceOther([other]);
        setNewServiceOther(other);
        return other;
      };
      // Find active cart with proper null/undefined checking
      const activeCartData = serviceOther.find((cart) => cart?.activeCart === activeCart);
      if (!activeCartData) {
        setServiceOther((prev) => [...prev, other]);
        setNewServiceOther(other);
        return other;
      };
        
      // Update the new service other state
      setDiscountType(activeCartData?.discountType);
      setCostType(activeCartData?.costType ? activeCartData?.costType : costType);
      setNewServiceOther(activeCartData);
      
      // Update the service other array with the active cart data
      const thisOther =  Array.isArray(serviceOther)
      ? serviceOther.map((cart) => 
          (cart?.activeCart === activeCart) ? activeCartData : cart
        )
      : [activeCartData];
      setServiceOther(thisOther);
      
      return activeCartData;
    } catch (error) {
      console.error("Error in handleSwitchMode:", error);
      setSwicthMode(false);
      setNewServiceOther({});
    }
  }

  const handleSaveDataService = async () => {
    try {
      // Parse shipping cost safely
      const shippingCost = Number(newServiceOther?.shippingCost) || 0;
  
      // Create a more concise and efficient update logic
      const updatedCartDatas = cartDatas.map((cart) => {
        // Only modify the active cart
        if (cart?.label !== activeCart) return cart;
  
        const originalPrice = cart?.data?.orderGroup?.sumPrice || 0;
        const sumPriceWithShipping = originalPrice + shippingCost;
  
        // Consolidate cart update with optional fields
        const updatedCart = {
          ...cart,
          data: {
            ...cart.data,
            orderGroup: {
              ...cart.data.orderGroup,
              sumPrice: sumPriceWithShipping,
              shippingCost,
              costTitle: costType,
              // Use optional chaining and nullish coalescing for optional fields
              ...(newServiceOther?.deliveryMethod && { deliveryMethod: newServiceOther.deliveryMethod }),
              ...(newServiceOther?.repairCost && { repairCost: newServiceOther.repairCost }),
              ...(newServiceOther?.addressCf && { addressCf: newServiceOther.addressCf }),
              ...(newServiceOther?.note && { note: newServiceOther.note }),
              ...(newServiceOther?.cash ? { cash: Number(newServiceOther.cash) || 0 } : {cash: 0}),
              ...(newServiceOther?.transfer ? { transfer: Number(newServiceOther.transfer) || 0 } : {transfer: 0}),
              ...(newServiceOther?.debt ? { debt: Number(newServiceOther.debt) || 0, status: "INDEBTED" } : {debt: 0}),
              ...(newServiceOther?.discount ? { discount: Number(newServiceOther.discount) || 0 } : {discount: 0}),
              ...({ discountType: discountType })
            },
          },
        };
  
        return updatedCart;
      });
      // Use microtask to ensure state update
      queueMicrotask(() => {
        setCartDatas(updatedCartDatas);
        setSwicthMode(false);
        setReceivedMoney();
      });
      // Update serviceOther state
      const other = {...newServiceOther, discountType: discountType, costType: costType}
      const findIndex = serviceOther.findIndex((cart) => cart?.activeCart === activeCart);
      if (findIndex !== -1) {
        let updatedServiceOther = [...serviceOther];
        updatedServiceOther[findIndex] = other;
        setServiceOther(updatedServiceOther);
      } else {
        setServiceOther((prev) =>
          Array.isArray(prev)
            ? [...prev, other]
            : [other]
        );
      }
      setNewServiceOther({});
    } catch (error) {
      console.error("Error in handleSaveDataService:", error);
    }
  };

  // handle change to get value from service other
  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setNewServiceOther((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  
  // Handle input change
  const handleNumberChange = (e) => {
    const {name, value} = e.target;

    // Remove commas for storing the actual number
    const numericValue = value.replace(/,/g, '');
    setNewServiceOther((prevState) => ({
      ...prevState,
      [name]: numericValue,
    }));
  };
  
    return (
    <>
      <Modal
        show={showDetailSaleModal}
        centered
        onHide={() => {
          if (createOrderLoading || saleOfferPriceLoading) return;
          setShowDetailSaleModal(false);
          setSwicthMode(false);
          setNewServiceOther({});
        }}
        style={{ marginTop: 20 }}
        size="lg">
        <Modal.Body style={{ padding: 0, border: '10px solid #f2f2f2', borderRadius: 8, overflow: 'hidden' }}>
          {swicthMode ? (
            <div style={{ width: "100%", padding: "5em" }}>
              <h5>ບໍລິການອື່ນໆ</h5>
              <Form>
                <Row>
                  <Col>
                    <Form.Group className="mb-3 pt-1" controlId="exampleForm.ControlInput1">
                      <Form.Label className="d-flex gap-2">
                        <Button size="small" variant={costType === shipping_cost_title ? "secondary" : "outline-secondary"} onClick={() => setCostType(shipping_cost_title)}>{shipping_cost_title}</Button>
                        <Button size="small" variant={costType === repair_cost_title ? "secondary" : "outline-secondary"} onClick={() => setCostType(repair_cost_title)}>{repair_cost_title}</Button>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="0"
                        name="shippingCost"
                        size="large"
                        value={newServiceOther?.shippingCost}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3 pt-3" controlId="exampleForm.ControlInput1">
                      <Form.Label>ຮູບແບບການຈັດສົ່ງ</Form.Label>
                      <Form.Select name="deliveryMethod" value={newServiceOther?.deliveryMethod} onChange={handleInputChange} aria-label="delivery-method">
                        <option>--ເລືອກ--</option>
                        <option value="DELIVERY_TO">ສົ່ງເຖິງທີ່</option>
                        <option value="SHIPPING_COMPANY">ບໍລິສັດຂົນສົ່ງ</option>
                        <option value="OVERSEAS_DELIVERY">ສົ່ງຕ່າງປະເທດ</option>
                        <option value="PICKUP">ມາຮັບເຄື່ອງເອງ</option>
                      </Form.Select>
                    </Form.Group>

                  </Col>
                </Row>

                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>ສາຂາປາຍທາງ, ບ້ານ, ເມືອງ, ແຂວງ</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="ປ້ອນຂໍ້ມູນ..."
                    name="addressCf"
                    size="large"
                    value={newServiceOther?.addressCf}
                    onChange={handleInputChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                  <Form.Label>ໝາຍເຫດ (ຖ້າມີ)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="note"
                    size="large"
                    value={newServiceOther?.note}
                    onChange={handleInputChange}
                  />
                </Form.Group>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                      <Form.Label>ເງີນສົດ</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="ປ້ອນຈຳນວນເງີນສົດ"
                        name="cash"
                        size="large"
                        value={FormatNumber(newServiceOther?.cash)}
                        onChange={handleNumberChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                      <Form.Label>ເງີນໂອນ</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="ປ້ອນຈຳນວນເງີນໂອນ"
                        name="transfer"
                        size="large"
                        value={FormatNumber(newServiceOther?.transfer)}
                        onChange={handleNumberChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                      <Form.Label>ຕີດຫນີ້</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="ປ້ອນຈຳນວນເງີນຕີດຫນີ້"
                        name="debt"
                        size="large"
                        value={FormatNumber(newServiceOther?.debt)}
                        onChange={handleNumberChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                      <Form.Label className="d-flex gap-4 justify-content-start align-items-center">
                        ສ່ວນຫລຸດ
                        <Form.Check
                          type="radio"
                          id="allow-products"
                          label="₭"
                          name="discountType"
                          checked={discountType}
                          onChange={() => setDiscountType(true)}
                          disabled={promotionData?.status === "ACTIVED"}
                        />
                        <Form.Check
                          type="radio"
                          id="allow-products"
                          label="%"
                          name="discountType"
                          checked={!discountType}
                          onChange={() => setDiscountType(false)}
                          disabled={promotionData?.status === "ACTIVED"}
                        />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="ປ້ອນຈຳນວນເງີນສ່ວນຫລຸດ"
                        name="discount"
                        size="large"
                        value={FormatNumber(newServiceOther?.discount)}
                        onChange={handleNumberChange}
                        disabled={promotionData?.status === "ACTIVED"}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>

              <div className="d-flex justify-content-end gap-2 mt-4">
                <Button onClick={() => {setSwicthMode(false); setNewServiceOther({})}} variant="light" style={{ padding: '10px 20px' }}><ReactIcons.MdArrowBack /> ຍັກເລີກ</Button>
                <Button onClick={handleSaveDataService} variant="light" style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, padding: '10px 20px' }}><ReactIcons.FaCheck /> ຢືນຢັນ</Button>

              </div>

            </div>

          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: width < 463 ? "68px" : width < 993 ? "85px" : "50px",
                  padding: width < 463 ? "1em" : "1.45em",
                  borderRadius: "5px 5px 0px 0px",
                  justifyContent: "space-between",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: width > 993 ? 38 : width < 463 ? 14 : 20,
                  background:
                    receivedMoney === 0
                      ? LINEAR_GRADIENT_BG
                      : change < 0
                        ? "#D82C0D"
                        : change === 0
                          ? LINEAR_GRADIENT_BG
                          : LINEAR_GRADIENT_BG,
                  color:
                    receivedMoney === 0
                      ? "#fff"
                      : change < 0
                        ? "white"
                        : change === 0
                          ? "white"
                          : "#fff",
                  border: "none",
                  backgroundColor: LINEAR_GRADIENT_BG,
                }}>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: width < 463 ? 3 : width < 993 ? 4 : 7,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: width < 463 ? 3 : width < 993 ? 4 : 10,
                    }}
                  >
                    <Button
                      variant="light"
                      size={width < 993 ? "sm" : undefined}
                      style={width < 463 ? { padding: "2px 6px", fontSize: 11 } : width < 993 ? { padding: "4px 8px", fontSize: 12 } : {}}
                      onClick={() => {
                        handleSwitchMode();
                      }}
                    ><ReactIcons.BiTransfer style={{ fontSize: width < 463 ? 14 : width < 993 ? 16 : undefined }} />  ບໍລິການອື່ນໆ
                    </Button>
                    {
                      customername && (
                        <Button
                          variant="light"
                          size={width < 993 ? "sm" : undefined}
                          style={width < 463 ? { padding: "2px 6px", fontSize: 11 } : width < 993 ? { padding: "4px 8px", fontSize: 12 } : {}}
                          onClick={() => {
                            setShowRewardExchange(true);
                          }}
                        ><ReactIcons.BsGiftFill style={{ fontSize: width < 463 ? 14 : width < 993 ? 16 : undefined }} />  ແລກລາງວັນ
                        </Button>
                      )
                    }
                  </div>

                  {selectedReward && (
                    <div style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      border: "1px solid #eee",
                      padding: width < 463 ? "2px 4px" : "3px 5px",
                      borderRadius: 5,
                      gap: width < 463 ? 4 : width < 993 ? 6 : 10,
                    }}>
                      <div style={{ color: COLOR_WHITE, display: "flex", alignItems:"start", flexDirection: "column",fontWeight:400 }}>
                        <div style={{ fontSize: width < 463 ? 11 : width < 993 ? 12 : 14 }}>
                          ຊື່ລາງວັນ: <span>{selectedReward?.name}</span>
                        </div>
                        <div style={{ fontSize: width < 463 ? 11 : width < 993 ? 12 : 14 }}>
                          ປະເພດລາງວັນ: <span>{selectedReward?.rewardType === 'DISCOUNT' ? 'ສ່ວນຫຼຸດ' : 'ສິນຄ້າ'}</span>
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: width < 463 ? 4 : width < 993 ? 5 : 10 }}>
                        {/* <Button
                          variant="success"
                          size="sm"
                          style={width < 463 ? { padding: "2px 6px" } : width < 993 ? { padding: "4px 8px" } : {}}
                          onClick={handleConfirmRedeem}
                        >
                           {createRedeemLoading?  <div
                           style={{display:"flex", alignItems:"center", gap: width < 463 ? 4 : 5, fontSize: width < 463 ? 11 : width < 993 ? 12 : 14}}
                           >
                            <Spinner size="sm" />
                           </div>
                           :
                           <span style={{ fontSize: width < 463 ? 11 : width < 993 ? 12 : 14 }}>ຢືນຢັນ</span>}
                        </Button> */}
                        <Button
                          variant="light"
                          size="sm"
                          style={width < 463 ? { padding: "2px 6px" } : width < 993 ? { padding: "4px 8px" } : {}}
                          onClick={handleCancelSelectedReward}
                        >
                          <span style={{ fontSize: width < 463 ? 11 : width < 993 ? 12 : 14 }}>ຍົກເລີກ</span>
                        </Button>
                      </div>
                    </div>
                  )}
                </div>

                <div>
                    {/* <span className="text-decoration-line-through"> */}
                    <span style={{ fontSize: width < 463 ? 12 : undefined }}>
                    {receivedMoney === 0
                      ? t("total_price_tb") + ": " + numberFormat(money)
                      : parseFloat(change) < 0
                        ? t("not_enough_money") + ": " + numberFormat(change)
                        : parseFloat(change) > 0
                          ? t("refund_money") + ": " + numberFormat(change)
                          : parseFloat(change) === 0
                            ? t("enough_money") + ": " + numberFormat(money)
                            : t("total_price_tb") + ": " + numberFormat(money)}{" "}
                    {convertCurrency(selectedPayCurrency)}
                  </span>
                  <div style={{ fontSize: width < 463 ? 10 : width > 993 ? 16 : 12, color: "#b3b3b3ff", marginTop: 4 }}>
                    {
                      customername ? `ຄະແນນປັດຈຸບັນມີ: ${numberFormat(currentPoint ?? 0)} ຄະແນນ` : ""
                    }
                  </div>
                </div>

              </div>


              <div style={{ display: "flex" }}>
                <div
                  style={{
                    display: "flex",
                    color: activeTab === "CASH" ? APP_COLOR : "#616161",
                    justifyContent: "center",
                    textAlign: "center",
                    borderBottom:
                      "1px solid " + (activeTab === "CASH" ? APP_COLOR : "#eee"),
                    width: "100%",
                    backgroundColor: activeTab === "CASH" ? "#eee" : "#fff",
                    padding: "10px 0px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setIsBillPrinting(false)
                    setActiveTab("CASH")
                  }}>
                  <LocalAtm />
                  <span style={{ marginLeft: 5 }}>{t("cash_money_name")}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    color: activeTab === "TRANSFER" ? APP_COLOR : "#616161",
                    justifyContent: "center",
                    borderBottom:
                      "1px solid " + (activeTab === "TRANSFER" ? APP_COLOR : "#eee"),
                    textAlign: "center",
                    backgroundColor: activeTab === "TRANSFER" ? "#eee" : "#fff",
                    width: "100%",
                    padding: "10px 0px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setActiveTab("TRANSFER");
                    setReceivedMoney(money);
                    setIsBillPrinting(false)
                  }}>
                  {shopData?.shop?.isPaymentGateway ? (
                    <>
                      <img src="https://portal.lailaolab.la/images/newLogo.png" style={{ width: 30, marginRight: 4 }} alt="phapay logo" />  ຊຳລະດ້ວຍ QR
                    </>
                  ) : (
                    <>
                      <LocalAtm />
                      <span style={{ marginLeft: 5 }}>{t("transfer_money_name")}</span>
                    </>
                  )
                  }
                </div>
              </div>
              <div
                className="justify-content-md-center"
                style={{ padding: "15px", margin: 0, background: "#fff" }}
                tabIndex="0">
                <input
                  type="text"
                  value={numberFormat(receivedMoney ?? 0)}
                  onChange={(e) => handleChange(e)}
                  className="form-control"
                  style={{
                    border: `2px solid ${APP_COLOR}`,
                    height: "80px",
                    borderRadius: "15px",
                    backgroundColor: "#fff",
                    textAlign: "end",
                    color: APP_COLOR,
                    fontSize: "30px",
                    fontWeight: "bold",
                    paddingRight: "20px",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
                  }}
                />
              </div>
              <div style={{ display: "flex" }}>
                <NumberButton
                  disabled={
                    activeTab === t("transfer_money_name") ||
                    createOrderLoading ||
                    saleOfferPriceLoading
                  }
                  number={"1"}
                  onClick={() => handleClick("1")}
                />
                <NumberButton
                  disabled={
                    activeTab === t("transfer_money_name") ||
                    createOrderLoading ||
                    saleOfferPriceLoading
                  }
                  number={"2"}
                  onClick={() => handleClick("2")}
                />
                <NumberButton
                  disabled={
                    activeTab === t("transfer_money_name") ||
                    createOrderLoading ||
                    saleOfferPriceLoading
                  }
                  number={"3"}
                  onClick={() => handleClick("3")}
                />
                <NumberButton
                  disabled={
                    activeTab === t("transfer_money_name") ||
                    createOrderLoading ||
                    saleOfferPriceLoading
                  }
                  number={numberFormat("100000")}
                  onClick={() => setReceivedMoney("100000")}
                />
              </div>
              <div style={{ display: "flex" }}>
                <NumberButton
                  disabled={
                    activeTab === t("transfer_money_name") ||
                    createOrderLoading ||
                    saleOfferPriceLoading
                  }
                  number={"4"}
                  onClick={() => handleClick("4")}
                />
                <NumberButton
                  disabled={
                    activeTab === t("transfer_money_name") ||
                    createOrderLoading ||
                    saleOfferPriceLoading
                  }
                  number={"5"}
                  onClick={() => handleClick("5")}
                />
                <NumberButton
                  disabled={
                    activeTab === t("transfer_money_name") ||
                    createOrderLoading ||
                    saleOfferPriceLoading
                  }
                  number={"6"}
                  onClick={() => handleClick("6")}
                />
                {
                  shopData?.shop?.id === "63edde5526fb6c3c8465ba68" && activeTab === "TRANSFER" ?  // you can change this shop id that you want
                    <NumberButton
                      color={"#fff"}
                      background="#0071BC"
                      number={
                        <>
                          {/* <LuPrinterCheck style={{ fontSize: 24, marginRight: 5 }} /> */}
                          <span style={{ fontSize: 15 }}>{t("print_bill")}</span>
                        </>
                      }
                      onClick={async () => {
                        await setNotYetPaid(true);
                        await setIsBillPrinting(true);
                        onPrintBill()
                      }}
                    />
                    :
                    <NumberButton
                      disabled={
                        activeTab === t("transfer_money_name") ||
                        createOrderLoading ||
                        saleOfferPriceLoading
                      }
                      number={numberFormat("50000")}
                      onClick={() => setReceivedMoney("50000")}
                    />
                }
              </div>
              <div style={{ display: "flex" }}>
                <NumberButton
                  disabled={
                    activeTab === t("transfer_money_name") ||
                    createOrderLoading ||
                    saleOfferPriceLoading
                  }
                  number={"7"}
                  onClick={() => handleClick("7")}
                />
                <NumberButton
                  disabled={
                    activeTab === t("transfer_money_name") ||
                    createOrderLoading ||
                    saleOfferPriceLoading
                  }
                  number={"8"}
                  onClick={() => handleClick("8")}
                />
                <NumberButton
                  disabled={
                    activeTab === t("transfer_money_name") ||
                    createOrderLoading ||
                    saleOfferPriceLoading
                  }
                  number={"9"}
                  onClick={() => handleClick("9")}
                />
                {/* <NumberButton disabled={activeTab === 'ເງິນໂອນ' || createOrderLoading || saleOfferPriceLoading} number={numberFormat('20000')} onClick={() => setReceivedMoney('20000')} /> */}
                {/* //TODO ຄ້າງໜິ້ Button Click */}
                {width > 993 ?
                  <NumberButton
                    color={"#fff"}
                    background="#cc2121"
                    number={
                      createOrderNotYetPaidLoading ? (
                        <Spinner />
                      ) : (
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          {t("debt_btn_name")}
                        </div>
                      )
                    }
                    onClick={async () => {
                      await setNotYetPaid(true);
                      if (createOrderNotYetPaidLoading) return;
                      if (receivedMoney - totalPricePay < 0)
                        return errorSwal("ຈໍານວນເງິນບໍ່ພໍ");
                      setIsBillPrinting(false)
                      handleOpentOfferprice()

                      // onPrintBill();
                      // onCreateManyOrderWithOrderGroupNotYetPaid();
                    }}
                  />
                  :
                  <NumberButton
                    number={
                      selectedPayCurrency === "LAK"
                        ? "฿"
                        : selectedPayCurrency === "USD"
                          ? "₭"
                          : "$"
                    }
                    onClick={() => {
                      if (selectedPayCurrency === "LAK") {
                        setReceivedMoney(0);
                        return setSelectedPayCurrency("BAHT");
                      }
                      if (selectedPayCurrency === "BAHT") {
                        setReceivedMoney(0);
                        return setSelectedPayCurrency("USD");
                      }
                      if (selectedPayCurrency === "USD") {
                        setReceivedMoney(0);
                        return setSelectedPayCurrency("LAK");
                      }
                    }}
                  />}
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ width: "100%" }}>
                  <div style={{ display: "flex", width: "100%" }}>
                    <NumberButton
                      disabled={
                        activeTab === t("transfer_money_name") ||
                        createOrderLoading ||
                        saleOfferPriceLoading
                      }
                      number={"c"}
                      onClick={() => setReceivedMoney("")}
                    />
                    {/* <NumberButton disabled={activeTab === 'ເງິນໂອນ' || createOrderLoading || saleOfferPriceLoading} number={'.'} onClick={() => setReceivedMoney('')} /> */}
                    <NumberButton
                      disabled={
                        activeTab === t("transfer_money_name") ||
                        createOrderLoading ||
                        saleOfferPriceLoading
                      }
                      number={"0"}
                      onClick={() => handleClick("0")}
                    />
                    <NumberButton
                      disabled={
                        activeTab === t("transfer_money_name") ||
                        createOrderLoading ||
                        saleOfferPriceLoading
                      }
                      number={<BackspaceOutlined />}
                      onClick={() => backspace()}
                    />
                    {/* //TODO ບໍ່ຮັບບິນ */}
                    <NumberButton
                      // height={160}
                      color={"#fff"}
                      // backgroundColor={APP_COLOR}
                      background="#3C169B"
                      number={
                        loadingSaleBill || saleOfferPriceLoading ? (
                          <Spinner />
                        ) : (
                          <>
                            <ReactIcons.TbPrinterOff style={{ fontSize: 24, marginRight: 5 }} />
                            <span style={{ fontSize: 15 }}>{t("not_get_bill")}</span>

                          </>
                        )
                      }
                      onClick={async () => {
                        if (loadingSaleBill || saleOfferPriceLoading) return;
                        if (receivedMoney - totalPricePay < 0)
                          return errorSwal("ຈໍານວນເງິນບໍ່ພໍ");
                        setIsBillPrinting(false)
                        await autoRedeemIfNeeded();
                        createOrderNotPrintBill();
                      }}
                    />
                  </div>
                  <div style={{ display: "flex" }}>
                    <NumberButton
                      disabled={
                        activeTab === t("transfer_money_name") ||
                        createOrderLoading ||
                        saleOfferPriceLoading
                      }
                      number={customername ?? <PersonAddAlt1Icon />}
                      onClick={() => setShowSelectCusTomer(true)}
                    />
                    {/* <NumberButton disabled={activeTab === 'ເງິນໂອນ' || createOrderLoading || saleOfferPriceLoading} number={'c'} onClick={() => setReceivedMoney('')} /> */}
                    <NumberButton
                      disabled={
                        activeTab === t("transfer_money_name") ||
                        createOrderLoading ||
                        saleOfferPriceLoading
                      }
                      number={t("enough_money")}
                      onClick={() => setReceivedMoney(money)}
                    />

                    {width > 993 && <NumberButton
                      number={
                        selectedPayCurrency === "LAK"
                          ? "฿"
                          : selectedPayCurrency === "USD"
                            ? "₭"
                            : "$"
                      }
                      onClick={() => {
                        if (selectedPayCurrency === "LAK") {
                          setReceivedMoney(0);
                          return setSelectedPayCurrency("BAHT");
                        }
                        if (selectedPayCurrency === "BAHT") {
                          setReceivedMoney(0);
                          return setSelectedPayCurrency("USD");
                        }
                        if (selectedPayCurrency === "USD") {
                          setReceivedMoney(0);
                          return setSelectedPayCurrency("LAK");
                        }
                      }}
                    />}
                    <ReactToPrint
                      trigger={() => (
                        <NumberButton
                          color={APP_COLOR}
                          number={
                            <>
                              <ReactIcons.AiOutlineUsb />  USB
                            </>
                          }
                        />
                      )}
                      onAfterPrint={handleCreateOrderForPrintUsb}
                      content={() => bill80Ref.current}
                    />
                    {printBillA4 && (
                      <NumberButton
                        color={APP_COLOR}
                        number={"A4"}
                        onClick={handlePrintA4}
                      />
                    )}
                    {
                      printBillA4 ? (
                        <>
                          <NumberButton
                              color="#fff"
                              minWidth={width > 993 ? 195 : 90}
                              background={LINEAR_GRADIENT_BG}
                              number={
                                loadingPrintBill || saleOfferPriceLoading ? (
                                  <Spinner />
                                ) : (
                                  <>
                                    <ReactIcons.BsFillPrinterFill style={{ fontSize: 24, marginRight: 5 }} />
                                    <span style={{ fontSize: 15 }}>{previewingA4 ? t("preview_printing") : (createOrderLoading ? t("creating_order") : t("get_bill_a4"))}</span>
                                  </>
                                )
                              }
                              onClick={handlePrintA4}
                            />
                          <ReactToPrint
                            ref={printA4Ref}
                            content={() => billA4Ref.current}
                            onAfterPrint={handleAfterPrintA4}
                          />
                        </>
                      ) : (
                        <> {/* //TODO Receive Bill */}
                          <NumberButton
                            color={"#fff"}
                            minWidth={width > 993 ? 195 : 90}
                            background={LINEAR_GRADIENT_BG}
                            number={
                              loadingPrintBill || saleOfferPriceLoading ? (
                                <Spinner />
                              ) : (
                                <>
                                  <ReactIcons.BsFillPrinterFill style={{ fontSize: 24, marginRight: 5 }} />
                                  <span style={{ fontSize: 15 }}>{t("get_bill")}</span>
                                </>
                              )
                            }
                            onClick={async () => {
                              if (loadingPrintBill || saleOfferPriceLoading) return;
                              if (receivedMoney - totalPricePay < 0) return errorSwal("ຈໍານວນເງິນບໍ່ພໍ");
                              await setNotYetPaid(false);
                              await setIsBillPrinting(true);
                              await autoRedeemIfNeeded();
                              // await _loadGenCode();
                              createOrderPrintBill();
                            }}
                          />
                        </>
                      )
                    }
                  </div>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
      <RewardExchangeModal
        show={showRewardExchange}
        onClose={() => setShowRewardExchange(false)}
        onSelectReward={handleSelectReward}
        userconfirmId={userconfirmId}
      />
    </>
  );
}

export default CalculatorModal;
